/**
 * AppEmptyState — wrapper sobre Polaris EmptyState.
 * Visual: idéntica a Polaris EmptyState hoy.
 * Beneficio: las páginas no importan directamente @shopify/polaris.
 * Migración futura: cambiar solo este archivo.
 */
import { EmptyState, Text } from '@shopify/polaris';
import type { ReactNode } from 'react';

interface AppEmptyStateAction {
  content: string;
  onAction: () => void;
}

interface AppEmptyStateProps {
  heading: string;
  description?: string;
  image?: string;
  action?: AppEmptyStateAction;
  secondaryAction?: AppEmptyStateAction;
  children?: ReactNode;
}

export function AppEmptyState({
  heading,
  description,
  image = 'https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png',
  action,
  secondaryAction,
  children,
}: AppEmptyStateProps) {
  return (
    <EmptyState heading={heading} action={action} secondaryAction={secondaryAction} image={image}>
      {description ? (
        <Text as="p" variant="bodyMd">
          {description}
        </Text>
      ) : null}
      {children}
    </EmptyState>
  );
}
